require('./transfersOptionsButton.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
// @constants
const { BIZUM, SOLIDARITY } = require('constants/flagBasedFeatures');

class TransfersOptionsButton extends React.Component {
    buildOptions () {
        const { flagBasedFeatures, immAccount, hasBizumActive } = this.props;
        const accountId = immAccount.get('accountId');
        let options = [
            {
                link: '/myprofile/transfers/transfer',
                text: formatText('transfersOptions-makeNationalTransfer'),
                icon: 'transfers-options-button__icon icon-national-transfer'
            },
            {
                link: '/myprofile/transfers/pass',
                text: formatText('transfersOptions-makePass'),
                icon: 'transfers-options-button__icon icon-account-pass'
            },
            {
                link: '/myprofile/transfers/transfer',
                text: formatText('transfersOptions-makeInternationalTransfer'),
                icon: 'transfers-options-button__icon icon-international-transfer'
            },
            {
                link: `/myprofile/transfers/emited/${accountId}`,
                text: formatText('transfersOptions-reuseTransfer'),
                icon: 'transfers-options-button__icon icon-reuse-transfer'
            },
            {
                link: '/myprofile/transfers/transfer',
                text: formatText('transfersOptions-scheduleTransfer'),
                icon: 'transfers-options-button__icon icon-schedule-transfer'
            },
            ...flagBasedFeatures.get('charity-transfers-enabled') && flagBasedFeatures.get(SOLIDARITY) ? {
                link: '/myprofile/transfers/transfer/charity',
                text: formatText('transfersOptions-scheduleCharity'),
                icon: 'transfers-options-button__icon icon-schedule-charity'
            } : [],
            ...(__CONTACT_CENTER__ && flagBasedFeatures.get(BIZUM) && !hasBizumActive ? {
                link: '/myprofile/transfers/authorize-bizum',
                text: formatText('transfersOptions-authorizeBizumTransfer'),
                icon: 'transfers-options-button__icon icon-bizzum'
            } : []),
            ...(__CONTACT_CENTER__ && flagBasedFeatures.get(BIZUM) && hasBizumActive? {
                link: '/myprofile/transfers/cancel-bizum',
                text: formatText('transfersOptions-cancelBizumTransfer'),
                icon: 'transfers-options-button__icon icon-bizzum'
            } : [])
        ];
        
        return options;
    }

    render() {
        const contentClass = classNames('transfers-options-button', { 'hidden-xs': this.props.hiddenOnMobile });
        const dropdownStyleClasses = classNames('transfers-options-button__dropdown', { 'transfers-options-button__dropdown--cc': __CONTACT_CENTER__ });
        const options = this.buildOptions();
        const targetElement = (
            <div>
                <OKButton
                    modifier="primary"
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                >
                    <FormattedText value="transfersOptions-newTransfer" />
                </OKButton>
            </div>
        );
        
        return (
            <div className={contentClass}>
                <PopoverMenu
                    dropdownStyle={dropdownStyleClasses}
                    dropdownItemStyle="transfers-options-button__dropdown-item"
                    target={targetElement}
                    items={options}
                    placement="bottomRight"
                    hasArrow={false}
                />
            </div>
        );
    }
}

TransfersOptionsButton.propTypes = {
    hiddenOnMobile: PropTypes.bool,
    immAccount: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    reset: PropTypes.func,
    hasBizumActive: PropTypes.bool
};

module.exports = TransfersOptionsButton;

module.exports = withFeatureToggling(TransfersOptionsButton);
